// Reveals .js-animate-in elements (adds .visible) as they come on screen,
// staggered 200ms apart when several appear together.
//
// Uses an IntersectionObserver rather than checking positions on scroll:
// the browser reports an element whenever it enters the viewport for ANY
// reason - scrolling, but also the layout settling after web fonts and
// images finish loading, or a resize. The old document.ready + scroll-only
// check measured the page before that settling, so something that ended up
// on screen at load (e.g. the highlight bar under the hero, momentarily
// pushed below the fold by fallback-font text and unsized images) stayed
// hidden until the visitor scrolled.
//
// checkAnimateInElements() stays the public entry point - utils.js calls
// it after AJAX-loading more posts, and it picks up (starts observing) any
// .js-animate-in elements added since the last call.

var animateInObserver = null;

// Reveals a batch of elements that came on screen together, staggered 200ms
// apart. The stagger starts from zero for every batch (one observer
// callback, or one fallback check) - a running delay carried across
// batches kept growing while the visitor scrolled, so elements lagged
// further and further behind.
function revealAnimateInElements(elements) {
    var delay = 0;

    elements.forEach(function (element) {
        var $element = $(element);

        if ($element.hasClass('visible')) {
            return;
        }

        setTimeout(function () {
            $element.addClass('visible');
        }, delay);

        delay += 200;
    });
}

// Fallback for browsers without IntersectionObserver - the original
// position check.
function isElementInView(element) {
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
}

function checkAnimateInElements() {
    var $pending = $('.js-animate-in').not('.visible');

    if (animateInObserver) {
        // Observe anything not already observed (IntersectionObserver
        // ignores repeat observe() calls, but the flag avoids the work).
        $pending.each(function () {
            if (!this.animateInObserved) {
                this.animateInObserved = true;
                animateInObserver.observe(this);
            }
        });
        return;
    }

    revealAnimateInElements($pending.filter(function () {
        return isElementInView(this);
    }).get());
}

$(document).ready(function () {
    if ('IntersectionObserver' in window) {
        animateInObserver = new IntersectionObserver(function (entries, observer) {
            // Entries arrive in DOM order within a batch, so the stagger
            // runs top to bottom as before.
            var visible = [];

            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    visible.push(entry.target);
                }
            });

            revealAnimateInElements(visible);
        });

        checkAnimateInElements();
        return;
    }

    // Fallback: check now, once everything has loaded (fonts/images can
    // shift the layout after document.ready), and on scroll/resize.
    checkAnimateInElements();

    $(window).on('load scroll resize orientationchange', function () {
        checkAnimateInElements();
    });
});
